<template>
  <div class="page-content">
    <!-- 角色搜索以及添加栏目 -->
    <div class="function-wrap">
      <div class="left">
        <el-input placeholder="请输入事件名称" v-model.trim="inputVal" @keyup.13.native="handlerKeyUp">
          <el-button slot="append" icon="el-icon-search" @click="demand"></el-button>
        </el-input>
        <el-select
          placeholder="请选择类型"
          style="width:20%;"
          v-model="optionVal"
          @change="sel"
          >
          <el-option
            v-for="item in optionArr"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="timeValue" @change="selChange" placeholder="请选择时间" style="width:20%;margin:0 10px">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
            :clearable="false"
            v-show="showDate"
            v-model="dateTime"
            @change="dateChage"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="acellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
          label="创建时间">
         <template slot-scope="scope">
            <div>
              {{dateFormat(scope.row.createTime)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
         prop="identifier"
          label="标识符 ">
        </el-table-column>
        <el-table-column
         prop="identifierName"
          label="事件名称">
        </el-table-column>
        <el-table-column
         prop="identifierType"
          label="事件类型">
        </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
         prop="outputData"
          label="输出参数">
          <template slot-scope="scope">
            {{JSON.stringify(scope.row.outputData)}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页管理 -->
      <el-row
        class="pagination-container"
        type="flex" justify="end"
        >
        <!-- 页码按钮的数量currenCurrent  sizeChange -->
        <el-pagination
          :current-page.sync="listQuery.page"
          :page-sizes="[2,5,10,20,30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"/>
      </el-row>
  </div>
</template>

<script>
import { deviceEventLogList } from '@/api/deviceManagement'
import { dateFormat } from '@/assets/js/tools.js'
export default {
  props: ['deviceDetail', 'events'],
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      // ------------
      tableData: [],
      eventsList: [],
      // checked: false,
      btnsName: '',
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      optionArr: [
        {
          id: 1,
          name: 'info'
        },
        {
          id: 2,
          name: 'error'
        },
        {
          id: 3,
          name: 'alert'
        },
        {
          id: 4,
          name: '全部类型'
        }
      ],
      optionVal: 4,
      // time
      options: [
        {
          value: '1',
          label: '1小时'
        }, {
          value: '2',
          label: '24小时'
        }, {
          value: '3',
          label: '7天'
        }, {
          value: '4',
          label: '自定义'
        }
      ],
      timeValue: '1',
      // timePicker
      showDate: false,
      dateTime: '',
      // 搜索
      inputVal: '',
      dateParams: {
        startTime: '',
        endTime: ''
      },
      dateFormat: dateFormat
    }
  },
  created () {
    this.eventsList = this.events
    this.getDate(this.timeValue)
    this.$nextTick(() => {
      this.getDeviceEventLogList()
    })
  },
  methods: {
    sel () {
      this.getDeviceEventLogList()
    },
    getDeviceEventLogList () {
      const params = {
        deviceName: this.deviceDetail.deviceName,
        productKey: this.deviceDetail.productKey,
        startTime: this.dateParams.startTime,
        endTime: this.dateParams.endTime,
        identifier: this.inputVal,
        identifierType: this.optionVal === 1 ? 'info' : this.optionVal === 2 ? 'errot' : this.optionVal === 3 ? 'alert' : '',
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      deviceEventLogList(params).then((res) => {
        const resData = res.data.data
        this.total = resData.recordCount
        this.tableData = resData.list
        console.log(this.eventsList)
        this.tableData.map((ele) => {
          const result = this.eventsList.find((item) => {
            return item.identifier === ele.identifier
          })
          // 去除当result为undefined时的情况
          if (result) {
            ele.identifierName = result.name
          }
        })
      })
    },
    // 类型切换
    selChange (value) {
      value === '4'
        ? this.showDate = true
        : (
          this.showDate = false,
          // 初始起始时间
          this.getDate(value),
          this.getDeviceEventLogList()
        )
    },
    getDate (type) {
      // 用于获起始时间的时间戳,毫秒
      const dateParams = {
        beginTime: Date.parse(new Date()),
        endTime: Date.parse(new Date()),
        oneHourTiem: 60 * 60 * 1000,
        oneDayTime: 24 * 60 * 60 * 1000
      }
      this.dateParams.endTime = dateParams.endTime
      type === '1'// 小时
        ? this.dateParams.startTime = dateParams.beginTime - dateParams.oneHourTiem
        : type === '2'// 24小时
          ? this.dateParams.startTime = dateParams.beginTime - dateParams.oneDayTime
          : type === '3'// 7天
            ? this.dateParams.startTime = dateParams.beginTime - (dateParams.oneDayTime * 7)
            : ''
    },
    // 时间切换
    dateChage () {
      this.listQuery.page = 1
      if (this.dateParams.startTime && this.dateParams.endTime) {
        this.dateParams.startTime = Date.parse(this.dateTime[0])
        this.dateParams.endTime = Date.parse(this.dateTime[1])
      }
      // 获取数据
      this.getDeviceEventLogList()
    },
    // inputVal
    handlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.getDeviceEventLogList()
      }
    },
    // 根据固件名查询列表
    demand () {
      // this.params.firmwareName = this.input
      this.getDeviceEventLogList()
    },
    // 分页管理
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getDeviceEventLogList()
    },
    // 改变页码
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getDeviceEventLogList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .function-wrap{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
      .left{
        display: flex;
        .el-input {
          width: 200px;
          margin-right: 10px;
        }
      }
      .right{
        .el-button{
          display: flex;
          width: 40px;
          height: 40px;
          font-size: 16px;
          justify-content: center;
          /deep/ .el-icon-refresh-right{
            font-size: 20px;
          }
        }
      }
    }

    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
      .opreationBtn{
        .check,.edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .onlineStatus{
        .online{
          color: #138c4b;
        }
        .offline{
          color: red
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
    .col{
      margin-right: 20px;
    }
}
</style>
<style>
  .el-tooltip__popper{
    max-width:30%;
  }
  .el-tooltip__popper,
  .el-tooltip__popper.is-dark{
    background:rgb(48, 65, 86) !important;
    color: #fff !important;
    line-height: 24px;
  }
</style>
